import ExpandableText from 'client/common/components/expandable-text';

import './index.css';

export default ExpandableText;
